let locales = {
    HistoryPAStates_title: 'Historial del proceso de parnerAfiliati',
    HistoryPAStates_seeMore: 'Ver más',
};

export default locales;